import React from 'react';

// Main App component for the Dashboard Selector Page
const App = () => {
  return (
    <div className="font-sans antialiased text-gray-800 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen flex flex-col items-center justify-center p-4">
      {/* Main Content Container */}
      <main className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 lg:p-16 max-w-4xl w-full text-center transform transition-all duration-500 ease-in-out scale-100 hover:scale-[1.01] flex flex-col items-center">
        {/* Welcome Section */}
        <div className="mb-10">
          <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 leading-tight mb-4 animate-fade-in-down">
            Welcome to <span className="text-blue-600">My Data Intel</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 animate-fade-in-up">
            Please select your dashboard platform to access your reports.
          </p>
        </div>

        {/* Dashboard Selection Cards */}
        <div className="flex flex-col md:flex-row gap-8 w-full max-w-2xl">
          {/* Superset Dashboard Card */}
          <a
            href="https://superset.mydataintel.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 bg-gradient-to-br from-purple-600 to-indigo-700 text-white p-8 rounded-2xl shadow-xl flex flex-col items-center justify-center space-y-4 cursor-pointer hover:from-purple-700 hover:to-indigo-800 transform hover:scale-105 transition-all duration-300 ease-in-out group"
          >
            {/* Superset Logo */}
            <img
              src="/superset-logo.png"
              alt="Superset Logo"
              className="w-20 h-20 object-contain rounded-full transition-transform duration-300 group-hover:scale-110"
              onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/80x80/6B46C1/FFFFFF?text=SS"; }} // Fallback placeholder
            />
            <h2 className="text-3xl font-bold mt-4">Superset Dashboards</h2>
            <p className="text-purple-100 text-lg">Access your powerful data visualizations and reports.</p>
            <span className="mt-4 inline-block bg-white text-indigo-700 font-semibold py-2 px-6 rounded-full shadow-md group-hover:bg-gray-100 transition-colors duration-300">
              Go to Superset
            </span>
          </a>

          {/* PowerBI Dashboard Card */}
          <a
            href="https://dashboards.bi-visuals.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 bg-gradient-to-br from-teal-500 to-green-600 text-white p-8 rounded-2xl shadow-xl flex flex-col items-center justify-center space-y-4 cursor-pointer hover:from-teal-600 hover:to-green-700 transform hover:scale-105 transition-all duration-300 ease-in-out group"
          >
            {/* Power BI Logo */}
            <img
              src="/power-bi-logo.png"
              alt="Power BI Logo"
              className="w-20 h-20 object-contain rounded-full transition-transform duration-300 group-hover:scale-110"
              onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/80x80/319795/FFFFFF?text=PBI"; }} // Fallback placeholder
            />
            <h2 className="text-3xl font-bold mt-4">Power BI Dashboards</h2>
            <p className="text-teal-100 text-lg">Explore interactive business intelligence reports.</p>
            <span className="mt-4 inline-block bg-white text-green-700 font-semibold py-2 px-6 rounded-full shadow-md group-hover:bg-gray-100 transition-colors duration-300">
              Go to Power BI
            </span>
          </a>
        </div>
      </main>

      {/* Footer */}
      <footer className="mt-12 text-gray-600 text-center text-sm">
        <p>&copy; {new Date().getFullYear()} My Data Intel. All rights reserved.</p>
      </footer>

      {/* Optional: Simple CSS for animations (can be extended with more complex Tailwind animations) */}
      <style>
        {`
          @keyframes fadeInDown {
            from { opacity: 0; transform: translateY(-20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-in-down {
            animation: fadeInDown 0.8s ease-out forwards;
          }
          .animate-fade-in-up {
            animation: fadeInUp 0.8s ease-out 0.2s forwards;
          }
        `}
      </style>
    </div>
  );
};

export default App;

